// MisOrdenes.js
import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../utils/config";
import OrderDetail from "../OrderDetail/OrderDetail"; // Asegúrate de importar tu componente de detalle de orden

const OrderContainer = ({ userId }) => {
  const [ordenes, setOrdenes] = useState([]);

  useEffect(() => {
    // Función asincrónica para obtener las órdenes del usuario desde Firebase
    const fetchOrdenes = async () => {
      try {
        const ordenesCollection = collection(db, "orders");
        const q = query(ordenesCollection, where("buyer.userId", "==", userId));
        const querySnapshot = await getDocs(q);

        const ordenesData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }));

        setOrdenes(ordenesData);
      } catch (error) {
        console.error("Error al obtener órdenes:", error);
      }
    };

    // Llama a la función para obtener las órdenes cuando el componente se monta
    fetchOrdenes();
  }, [userId]); // Asegúrate de incluir userId en las dependencias para que se actualice cuando cambie

  return (
    <div>
      <h2>Mis Órdenes</h2>
      {ordenes.map((orden) => (
        <OrderDetail key={orden.id} orden={orden} />
      ))}
    </div>
  );
};

export default OrderContainer;
